import { SET_ONLY_READ } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[SET_ONLY_READ](value);
